import { ReactElement, useState } from 'react'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Typograhpy from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Grow from '@mui/material/Grow'
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import metaEnv from '../../../helper/metaEnv'
import delay from '../../../utilitie/delay'


import useScreen from '../../../hook/misc/useScreen'
import { CancelButton, ConfirmButton } from '../Button'
import CheckSvgIcon from '../Icon/CheckSvgIcon'
import CloseSvgIcon from '../Icon/CloseSvgicon'
import { IRefReturn } from '../../../compiler/global.interface'



export interface IConfirmModalProps {
    onClose?: () => void;
    onConfirm: () => Promise<any> | any;
    callback?: (res: IRefReturn) => void; // callback active when modal close
    detail?: string;
    render?: JSX.Element;
    type?: 'deny' | 'accept'
}

export default function ConfirmModal({ onClose, onConfirm, detail, callback, render, type }: IConfirmModalProps): ReactElement {
    const _onClose = onClose ? onClose : () => { }
    const { isLoading, setIsLoading } = useScreen()
    const [statusType, setStatusType] = useState<'error' | 'success' | 'confirm'>('confirm')

    const textColorByStatus = {
        confirm: 'primary.dark',
        success: 'primary.dark',
        error: 'error.dark',
    }

    const bgColorByStatus = {
        confirm: 'primary.light',
        success: 'primary.light',
        error: 'error.light',
    }

    const iconbyStatus: { [k: string]: any } = {
        confirm: <QuestionMarkIcon sx={{ fontSize: '6rem', color: 'primary.dark' }} />,
        success: <CheckSvgIcon />,
        error: <CloseSvgIcon />,
    }


    const handleConfirm = async (): Promise<void> => {
        if (!onConfirm) return

        const isShowLoading = onConfirm?.constructor?.name === "AsyncFunction";;
        let data: any, isError = false

        if (isShowLoading) {
            setIsLoading(true)
            try {
                data = await onConfirm()
                setStatusType('success')
            } catch (error) {
                metaEnv.isDev && console.log('error on confirm => ', error)
                isError = true
                setStatusType('error')
            }
            setIsLoading(false)
            await delay(1.5 * 1000, _onClose)
            callback && callback({ data, isError })
        } else {
            try {
                data = onConfirm()
            } catch (error) {
                metaEnv.isDev && console.log('error on confirm => ', error)
                isError = true
                setStatusType('error')
            }
            if (isError) await delay(1.5 * 1000, _onClose)
            else _onClose()
            callback && callback({ data, isError })
        }
    }

    const disabledButton = isLoading

    return (
        <Modal
            open={true}
        >
            <Paper sx={{
                outline: 'none',
                position: 'absolute' as 'absolute',
                top: '50%',
                left: '50%',
                overflowX: 'hidden',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                width: { xs: '100%', sm: 500 }
            }}>
                <Stack>
                    <Stack px={3} pt={1} direction={'row'} justifyContent={'flex-end'}>
                        {
                            !!(statusType === 'confirm') && (
                                <IconButton onClick={_onClose} sx={{ flex: 0, p: 1 }}>
                                    <CloseIcon />
                                </IconButton>
                            )
                        }
                    </Stack>

                    {/* content */}
                    <Stack px={3} py={4} alignItems={'center'} justifyContent={'flex-start'} spacing={4} maxHeight={300} overflow={'auto'}>
                        <Grow in={true}>
                            {
                                !!(type === 'deny' && statusType === 'confirm') ? (
                                    <Box sx={{ flexShrink: 0, display: 'grid', placeContent: 'center' }} width={128} height={128} margin={'0 auto'} borderRadius={140} bgcolor={bgColorByStatus['error']}>
                                        <WarningAmberIcon sx={{ fontSize: '6rem', color: 'error.dark' }} />
                                    </Box>
                                ) : (
                                    <Box sx={{ flexShrink: 0, display: 'grid', placeContent: 'center' }} width={128} height={128} margin={'0 auto'} borderRadius={140} bgcolor={bgColorByStatus[statusType]}>
                                        {iconbyStatus[statusType]}
                                    </Box>
                                )
                            }
                        </Grow>
                        <Typograhpy color={!!(type === 'deny' && statusType === 'confirm') ? 'error.main' : textColorByStatus[statusType]} variant="h6" textAlign={'center'}  >
                            {!!(statusType === 'confirm') && <>{detail}</>}
                            {!!(statusType === 'error') && <>ดำเนินการไม่สำเร็จ</>}
                            {!!(statusType === 'success') && <>ดำเนินการสำเร็จ</>}
                        </Typograhpy>
                    </Stack>

                    {/* custom render */}
                    {!!(render && statusType === 'confirm') && <>{render}</>}

                    {/* footer button */}
                    <Stack px={3} py={2} direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2}>
                        {
                            !!(statusType === 'confirm') && (
                                <>
                                    {/* @ts-ignore */}
                                    <CancelButton disabled={disabledButton} onClick={_onClose} {...(!!(type === 'deny') && { color: "black" })}>ยกเลิก</CancelButton>
                                    <ConfirmButton loading={disabledButton} disabled={disabledButton} onClick={handleConfirm} {...(!!(type === 'deny') && { color: "error", variant: 'outlined' })}>ตกลง</ConfirmButton>
                                </>
                            )
                        }
                    </Stack>
                </Stack>
            </Paper>
        </Modal >
    );
}

